import React from 'react';
import { apiRequest } from '../actions/apiActions.js';
import { 
    showLoading,
    hideLoading,
    addUiMsg,
    updateApiSpinner } from '../actions/uiActions.js';
import { apiUrls,apiVersion } from '../../apiUrls.js';
import {
    LOAD_CATEGORY,
    PROCESS_CATEGORY,
    CATEGORY_ERROR,
    insertCategoryDetails,
    LOAD_ASSIGNMENT_SUMMARY,
    PROCESS_ASSIGNMENT_SUMMARY,
    PROCESS_APPEND_ASSIGNMENT_SUMMARY,
    ASSIGNMENT_ERROR,
    insertAssignmentSummary,
    appendAssignmentSummary,
    LOAD_UNMATCHED_DEVICES,
    PROCESS_UNMATCHED_DEVICES,
    PROCESS_APPEND_UNMATCHED_DEVICES,
    UNMATCHED_DEVICES_ERROR,
    insertUnmatchedDevices,
    appendUnmatchedDevices,
    MAKE_DEVICE_ASSIGNMENT,
    insertPostConflictDevices,
    MAKE_CONFLICT_ASSIGNMENT,
    insertPostConflictDevicesForConflictUsers,
    PROCESS_CONFLICT_ASSIGNMENT,
    PROCESS_DEVICE_ASSIGNMENT,
    DEVICE_ASSIGNMENT_ERROR,
    CLEAR_EXISTING_ASSIGNMENTS,
    PROCESS_CLEAR_EXISTING_ASSIGNMENTS,
    CLEAR_ASSIGNMENT_ERROR
} from '../actions/assignDevicesActions.js';
import { messageTypes } from '../../components/ui/AlertMessage';
import { FormattedMessage } from 'react-intl';
import { errorDisplay } from '../../utilities/general';


export const loadCategoryList = (store) => (next) => (action) => {
  next(action);
  if (action.type === LOAD_CATEGORY) {
    const body = null;
    const meta = {
      method: 'GET',
      url:apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].alarmdevicetype + "?assignable=true",
      onSuccess: PROCESS_CATEGORY,
      onError: CATEGORY_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ categoryListReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processCategoryList = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_CATEGORY) {
      store.dispatch(hideLoading());
      const initialArray = action.payload.results;
    const types = {};
    initialArray.map((device) => {
      types[device.alarm_device_type] = { ...device };
      return '';
    });
    store.dispatch(updateApiSpinner({ categoryListReturned: true }));
    store.dispatch(insertCategoryDetails(types));
  }
};

export const loadCategoryError = (store) => (next) => (action) => {
  next(action);
  if (action.type === CATEGORY_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="assignDevicesMiddleware.categoryListErrorText"
          defaultMessage="There was an error"
          description="The category list were not able to be loaded"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const loadAssignmentSummary = (store) => (next) => (action) => {
    next(action);
    if (action.type === LOAD_ASSIGNMENT_SUMMARY) {
      const body = null;
      const meta = {
        method: 'GET',
        url:
          apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + action.payload.assignTo + '/?alarm_device_type=' + action.payload.category + '&clear=' + action.payload.clear + '&assignable=true',
        onSuccess: PROCESS_ASSIGNMENT_SUMMARY,
        onError: ASSIGNMENT_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
  
      store.dispatch(showLoading());
      store.dispatch(updateApiSpinner({ assignmentSummaryReturned: false }));
      store.dispatch(apiRequest(body, meta));
    }
  };

export const processAssignmentSummary = (store) => (next) => (action) => {
    next(action);
    if (action.type === PROCESS_ASSIGNMENT_SUMMARY) {
      if (action.payload.next) {
        const body = null;
        const meta = {
          method: 'GET',
          url: action.payload.next,
          onSuccess: PROCESS_APPEND_ASSIGNMENT_SUMMARY,
          onError: ASSIGNMENT_ERROR,
          auth: store.getState().auth.token,
          body: false,
        };
        store.dispatch(apiRequest(body, meta));
      } else {
        store.dispatch(hideLoading());
        store.dispatch(updateApiSpinner({ assignmentSummaryReturned: true }));
      }
      store.dispatch(insertAssignmentSummary(action.payload.results));
    }
};

export const processAppendAssignmentSummary = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_ASSIGNMENT_SUMMARY) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_ASSIGNMENT_SUMMARY,
        onError: ASSIGNMENT_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ assignmentSummaryReturned: true }));
    }
    store.dispatch(appendAssignmentSummary(action.payload.results));
  }
};

export const loadAssignmentSummaryError = (store) => (next) => (action) => {
    next(action);
    if (action.type === ASSIGNMENT_ERROR) {
      store.dispatch(hideLoading());
      const messageText = (
        <React.Fragment>
          <FormattedMessage
            id="assignDevicesMiddleware.assignmentSummaryErrorText"
            defaultMessage="There was an error"
            description="The assignment summary were not able to be loaded"
          />
        </React.Fragment>
      );
      const errors = action.payload;
      const message = {
        message: messageText,
        error: errorDisplay(errors),
        messageType: messageTypes.danger,
      };
  
      store.dispatch(addUiMsg(message));
    }
  };
  
  export const loadUnmatchedDevicesList = (store) => (next) => (action) => {
    next(action);
    if (action.type === LOAD_UNMATCHED_DEVICES) {
      const unMatch = '/unmatch';
      const alarmDeviceType = '?alarm_device_type=';
      const assignable = '&assignable=true';
      const body = null;
      const meta = {
        method: 'GET',
        url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + action.payload.assignTo + unMatch + alarmDeviceType + action.payload.category + assignable,
         // apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + action.payload.assignTo + '/unmatch' +'?alarm_device_type=' + action.payload.category + '&assignable=true',
        onSuccess: PROCESS_UNMATCHED_DEVICES,
        onError: UNMATCHED_DEVICES_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
  
      store.dispatch(showLoading());
      store.dispatch(updateApiSpinner({ unmatchedDevicesReturned: false }));
      store.dispatch(apiRequest(body, meta));
    }
  };

export const processUnmatchedDevicesList = (store) => (next) => (action) => {
    next(action);
    if (action.type === PROCESS_UNMATCHED_DEVICES) {
      if (action.payload.next) {
        const body = null;
        const meta = {
          method: 'GET',
          url: action.payload.next,
          onSuccess: PROCESS_APPEND_UNMATCHED_DEVICES,
          onError: UNMATCHED_DEVICES_ERROR,
          auth: store.getState().auth.token,
          body: false,
        };
        store.dispatch(apiRequest(body, meta));
      } else {
        store.dispatch(hideLoading());
      }
      store.dispatch(updateApiSpinner({ unmatchedDevicesReturned: true }));
      store.dispatch(insertUnmatchedDevices(action.payload.results));
    }
};

export const processAppendUnmatchedDevicesList = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_APPEND_UNMATCHED_DEVICES) {
    if (action.payload.next) {
      const body = null;
      const meta = {
        method: 'GET',
        url: action.payload.next,
        onSuccess: PROCESS_APPEND_UNMATCHED_DEVICES,
        onError: UNMATCHED_DEVICES_ERROR,
        auth: store.getState().auth.token,
        body: false,
      };
      store.dispatch(apiRequest(body, meta));
    } else {
      store.dispatch(hideLoading());
    }
    store.dispatch(updateApiSpinner({ unmatchedDevicesReturned: true }));
    store.dispatch(appendUnmatchedDevices(action.payload.results));
  }
};

export const loadUnmatchedDevicesError = (store) => (next) => (action) => {
    next(action);
    if (action.type === UNMATCHED_DEVICES_ERROR) {
      store.dispatch(hideLoading());
      const messageText = (
        <React.Fragment>
          <FormattedMessage
            id="assignDevicesMiddleware.unMatchedDevicesErrorText"
            defaultMessage="There was an error"
            description="Unmatched Devices were not able to be loaded"
          />
        </React.Fragment>
      );
      const errors = action.payload;
      const message = {
        message: messageText,
        error: errorDisplay(errors),
        messageType: messageTypes.danger,
      };
  
      store.dispatch(addUiMsg(message));
    }
  };

export const makeDeviceAssignmentRequest = (store) => (next) => (action) => {
  next(action);
  if (action.type === MAKE_DEVICE_ASSIGNMENT) {
    const body = [...action.payload.data];
    const meta = {
      method: 'POST',
      url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + action.payload.assignTo + '/', 
      onSuccess: PROCESS_DEVICE_ASSIGNMENT,
      onError: DEVICE_ASSIGNMENT_ERROR,
      auth: store.getState().auth.token,
      body: true,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ deviceAssignmentReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processDeviceAssignmentRequest = (store) => (next) => (action) => {
    next(action);
    if (action.type === PROCESS_DEVICE_ASSIGNMENT) {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ deviceAssignmentReturned: true }));
      store.dispatch(insertPostConflictDevices({data:[...action.payload]}));
    }
};

export const makeConflictAssignmentRequest = (store) => (next) => (action) => {
  next(action);
  if (action.type === MAKE_CONFLICT_ASSIGNMENT) {
    const body = [...action.payload.data];
    const meta = {
      method: 'POST',
      url:
        apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + 'users/', 
      onSuccess: PROCESS_CONFLICT_ASSIGNMENT,
      onError: DEVICE_ASSIGNMENT_ERROR,
      auth: store.getState().auth.token,
      body: true,
    };

    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ conflictAssignmentReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};

export const processConflictAssignmentRequest = (store) => (next) => (action) => {
    next(action);
    if (action.type === PROCESS_CONFLICT_ASSIGNMENT) {
      store.dispatch(hideLoading());
      store.dispatch(updateApiSpinner({ conflictAssignmentReturned: true }));
      store.dispatch(insertPostConflictDevicesForConflictUsers({data:[...action.payload]}));
    }
};

export const deviceAssignmentError = (store) => (next) => (action) => {
    next(action);
    if (action.type === DEVICE_ASSIGNMENT_ERROR) {
      store.dispatch(hideLoading());
      const messageText = (
        <React.Fragment>
          <FormattedMessage
            id="assignDevicesMiddleware.deviceAssignmentErrorText"
            defaultMessage="There was an error"
            description="There was an error while assigning devices"
          />
        </React.Fragment>
      );
      const errors = action.payload;
      const message = {
        message: messageText,
        error: errorDisplay(errors),
        messageType: messageTypes.danger,
      };
  
      store.dispatch(addUiMsg(message));
    }
  };

export const clearExistingAssignments = (store) => (next) => (action) => {
  next(action);
  if (action.type === CLEAR_EXISTING_ASSIGNMENTS) {
    const clear = 'clear_existing_assignments';
    const alarmDeviceType = '?alarm_device_type=';
    let url = apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + clear + alarmDeviceType + action.payload.category;
    console.log(url)
    const body = null;
    const meta = {
      method: 'GET',
      url:
      apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].assignDevices + clear + alarmDeviceType + action.payload.category,
      onSuccess: PROCESS_CLEAR_EXISTING_ASSIGNMENTS,
      onError: CLEAR_ASSIGNMENT_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };
    store.dispatch(showLoading());
    store.dispatch(updateApiSpinner({ clearAssignmentReturned: false }));
    store.dispatch(apiRequest(body, meta));
  }
};


export const processClearExistingAssignments = (store) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_CLEAR_EXISTING_ASSIGNMENTS) {
    store.dispatch(hideLoading());
    store.dispatch(updateApiSpinner({ clearAssignmentReturned: true }));
    const messageText = (
      <React.Fragment>
        {'Existing Assignments were cleared'}
      </React.Fragment>
    );
    const message = {
      message: messageText,
      messageType: messageTypes.success,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const clearExistingAssignmentError = (store) => (next) => (action) => {
  next(action);
  if (action.type === CLEAR_ASSIGNMENT_ERROR) {
    store.dispatch(hideLoading());
    store.dispatch(updateApiSpinner({ clearAssignmentReturned: true }));
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="assignDevicesMiddleware.clearExistingAssignmentErrorText"
          defaultMessage="There was an error Please Try Again or Refresh"
          description="There was an error while clearing existing assignments"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

  
export const assignDevicesMdl = [
  loadCategoryList,
  processCategoryList,
  loadCategoryError,
  loadAssignmentSummary,
  processAssignmentSummary,
  processAppendAssignmentSummary,
  loadAssignmentSummaryError,
  loadUnmatchedDevicesList,
  processUnmatchedDevicesList,
  processAppendUnmatchedDevicesList,
  loadUnmatchedDevicesError,
  makeDeviceAssignmentRequest,
  processDeviceAssignmentRequest,
  makeConflictAssignmentRequest,
  processConflictAssignmentRequest,
  deviceAssignmentError,
  clearExistingAssignments,
  processClearExistingAssignments,
  clearExistingAssignmentError,
];